<template>
  <div>
    <div
      class="carousel-example"
      ref="content"
      v-if="ContextMenuItem && ContextMenuItem.children"
    >
      <swiper
        @slideChange="SlideChanged"
        :options="swiperOption"
        v-if="Mode === 'Tour'"
        ref="swiper"
      >
        <swiper-slide
          ref="slide"
          v-for="(swiperItem, swiperIndex) in ContextMenuItem.children"
          :key="swiperIndex"
        >
          <h3 style="font-size: 41px">
            {{ swiperItem.data.Title }}
          </h3>
          <br />
          <div v-html="swiperItem.data.Description"></div>
        </swiper-slide>
        <swiper-slide>
          <div
            v-if="!CurrentTourQuestionsJSON || CurrentTourQuestionsJSON.length == 0"
          >
            <h3 style="font-weight: 900; font-size: 41px">Hold tight ...</h3>
            <br />
            We are generating some questions to help you identify your
            progress...<br />
            <br />
            <span v-if="GeneratingQuestionsCount"
              >We will come up with about
              {{ GeneratingQuestionsCount }} questions.</span
            >

            <br />
          </div>
          <div
            v-else-if="QuestionsAnswered == CurrentTourQuestionsJSON.length"
            style="width: 80%; margin: 0 auto"
          >
            <img
              src="@/assets/images/pages/404.png"
              alt="graphic-404"
              class="mx-auto mb-4 max-w-full"
            />
            <h1 style="font-weight: 900">You made it!</h1>
            <span style="float: left">Thank you so much for the efforts.</span
            ><br /><br /><br />
            <vs-button
              @click="
                ResetTourData();
                CurrentTourQuestionsJSON = null;
                $emit('ModeChanged', '');
              "
              >Close tour</vs-button
            >
          </div>
          <div
            v-if="
              CurrentTourQuestionsJSON &&
              CurrentTourQuestionsJSON.length > 0 &&
              QuestionsAnswered < CurrentTourQuestionsJSON.length
            "
          >
            <div
              v-for="(question, questionIdx) in CurrentTourQuestionsJSON"
              :key="questionIdx"
            >
              <div v-if="!question.answered" class="question-wrapper">
                <h3>{{ question.t }}</h3>
                <div
                  v-for="(answer, answerIdx) in question.a"
                  :key="answerIdx"
                  @click="toggleAnswer(question, answer)"
                  v-if="!answer.hidden"
                >
                  <div class="answer-wrapper">
                    <div class="answer-text" v-if="!answer.hidden">
                      {{ answer.t }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <vs-button @click="$emit('ModeChanged', '')" v-if="false"
            >Finish</vs-button
          >
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <a
        v-if="Mode == 'Tour'"
        @click="EndTour"
        class="text-danger"
        style="
          position: fixed;
          bottom: 20px;
          right: 20px;
          font-weight: 900;
          cursor: pointer;
        "
      >
        Exit tour
      </a>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

